// Country list with international dialing codes (ISO-ish, common set).
export const COUNTRIES = [
  { name: "India", dial: "+91", code: "IN" },
  { name: "United States", dial: "+1", code: "US" },
  { name: "United Kingdom", dial: "+44", code: "GB" },
  { name: "Canada", dial: "+1", code: "CA" },
  { name: "Australia", dial: "+61", code: "AU" },
  { name: "United Arab Emirates", dial: "+971", code: "AE" },
  { name: "Saudi Arabia", dial: "+966", code: "SA" },
  { name: "Singapore", dial: "+65", code: "SG" },
  { name: "Netherlands", dial: "+31", code: "NL" },
  { name: "Germany", dial: "+49", code: "DE" },
  { name: "France", dial: "+33", code: "FR" },
  { name: "Spain", dial: "+34", code: "ES" },
  { name: "Italy", dial: "+39", code: "IT" },
  { name: "Ireland", dial: "+353", code: "IE" },
  { name: "Switzerland", dial: "+41", code: "CH" },
  { name: "Sweden", dial: "+46", code: "SE" },
  { name: "Norway", dial: "+47", code: "NO" },
  { name: "Belgium", dial: "+32", code: "BE" },
  { name: "Qatar", dial: "+974", code: "QA" },
  { name: "Kuwait", dial: "+965", code: "KW" },
  { name: "Oman", dial: "+968", code: "OM" },
  { name: "Bahrain", dial: "+973", code: "BH" },
  { name: "Malaysia", dial: "+60", code: "MY" },
  { name: "Sri Lanka", dial: "+94", code: "LK" },
  { name: "Nepal", dial: "+977", code: "NP" },
  { name: "Bangladesh", dial: "+880", code: "BD" },
  { name: "Pakistan", dial: "+92", code: "PK" },
  { name: "New Zealand", dial: "+64", code: "NZ" },
  { name: "South Africa", dial: "+27", code: "ZA" },
  { name: "Japan", dial: "+81", code: "JP" },
  { name: "China", dial: "+86", code: "CN" },
  { name: "Hong Kong", dial: "+852", code: "HK" },
  { name: "Other", dial: "+", code: "XX" },
];
